import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import Spinner from './../../../spinner/spinner';
import { getRevivalInfo } from '../queries/queries';
import { ErrorBoundary } from "../../../errorBoundary/errorBoundary";
import { DateRange } from "../../../common/dateRange/dateRange";

class WeeklyHeader extends Component {
  get phaseTitleMapping() {
    return {
      0: (revival) => `Before ${revival.title}`,
      1: (revival) => `Week ${revival.phaseWeekNumber} of ${revival.title} Preparation`,
      2: (revival) => `Week ${revival.phaseWeekNumber} of ${revival.title}`,
      3: (revival) => `Week ${revival.phaseWeekNumber} of non-Event mode`,
    }
  }

  render() {
    const { data: { loading, statistics } } = this.props;

    if (loading) {
      return <Spinner />;
    } else if (this.props.hasError) {
      return null;
    } else {
      const { revivalInfo } = statistics.churchManager;
      return (
        <div>
          <h2 className="stress">{this.phaseTitleMapping[revivalInfo.phase](revivalInfo)}</h2>
          <h4 className="stress">
            <DateRange startDate={this.props.periodStartTime} endDate={this.props.periodEndTime}/>
          </h4>
        </div>
      );
    }
  }
}

export default compose(
  graphql(getRevivalInfo, { options: { fetchPolicy: 'cache-and-network' } }), ErrorBoundary
)(WeeklyHeader);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/weeklyHeader.js